import moment from "moment-timezone";
import { getCompanyId, getToken} from "../../Auth";
import syncStorage from "../../syncStorage";
import { getCurrentTimezone } from "../../Utilities";
import memoryStorage from "../../memoryStorage";
import { isDev, getRealmDeviceObject } from "../../utils"
import { toast } from "../Toasts";
import { parseToken } from "../../domain/security/state/Token";

const searchDeviceOnDatabase = async (api, email) => {
    try {

        const realmDevice = getRealmDeviceObject();

        if (realmDevice?.id && realmDevice?.number) {
            const response = await api.post("/api/search_device", {
                number: realmDevice.number,
                id: realmDevice.id,
                deviceUid: syncStorage.get("deviceUID"),
                realmDevice: getRealmDeviceObject(),
                getDeviceUID: syncStorage.get("deviceUID"),
                companyId: getCompanyId(),
                email: email,
            });

            return response.data;
        }

        if (email) {
            const response = await api.post("/api/search_device", {
                deviceUid: syncStorage.get("deviceUID"),
                email: email,
            });

            return response.data;
        }

        const response = await api.post("/api/search_device", {
            deviceUid: syncStorage.get("deviceUID"),
            companyId: getCompanyId(),
        });

        return response.data;
    } catch (e) {
        await toast({
            type: "error",
            title: "We are sorry 😥.",
            content: `"Error in process: ${e}"`,
        });
        return { device: null };
    }
};

const setSessionTypeBasedOnSearchDevice = async (api, email) => {
    let result = {
        isPersonalDevice: false,
        isCorporate: true,
        device: null,
    };

    try {
        const response = await searchDeviceOnDatabase(api, email);

        if (response.device) {
            const device = response.device;

            result = {
                isPersonalDevice: device.isPersonalDevice,
                isCorporate: !device.isPersonalDevice,
                device,
            };

            return result;
        }

        return result;
    } catch (e) {
        await toast({
            type: "error",
            title: "We are sorry 😥.",
            content: `"Error in process: ${e}"`,
        });
        return result;
    }
};

const updateTemplatePassContentTypeViewOtherCase = async (api, template, sectionIndex, itemIndex, scenario, answer) => {
    try {
        let dispatch = memoryStorage.get("loadOutDispatch");

        if (scenario === "RTS") {
            dispatch = memoryStorage.get("rtsDispatch");
        }

        if (scenario === "FLEET_ADMIN") {
            dispatch = memoryStorage.get("fleetAdminDispatch");
        }

        let updatedTemplate = await setForUpdatedTemplate(template, sectionIndex, itemIndex, answer, scenario);

        let countSections = updatedTemplate.length;
        let currentItemsCount = updatedTemplate[sectionIndex].items.length;

        let updatedItem;

        try {
            updatedItem = updatedTemplate[sectionIndex].items[itemIndex];
        } catch (e) {
            await toast({
                type: "error",
                title: "We are sorry 😥.",
                content: `"Error in process: ${e}"`,
            });
        }

        if (itemIndex + 1 >= currentItemsCount) {
            if (sectionIndex + 1 >= countSections) {
                if (scenario === "LOAD_OUT") {
                    syncStorage.set("loadOutTemplate", updatedTemplate);
                } else if (scenario === "RTS") {
                    syncStorage.set("rtsTemplate", updatedTemplate);
                } else {
                    syncStorage.set("fleetAdminTemplate", updatedTemplate);
                }

                await dispatchAndUpdateForm(api, dispatch, updatedTemplate, scenario, "PASS_QUESTION", updatedItem);
                return;
            }

            updatedTemplate[sectionIndex + 1].items[0].current = true;
            updatedTemplate[sectionIndex + 1].items[0].completed = false;
        } else {
            updatedTemplate[sectionIndex].items[itemIndex + 1].current = true;
            updatedTemplate[sectionIndex].items[itemIndex + 1].completed = false;
        }

        if (scenario === "LOAD_OUT") {
            syncStorage.set("loadOutTemplate", updatedTemplate);
        } else if (scenario === "RTS") {
            syncStorage.set("rtsTemplate", updatedTemplate);
        } else {
            syncStorage.set("fleetAdminTemplate", updatedTemplate);
        }

        return await dispatchAndUpdateForm(api, dispatch, updatedTemplate, scenario, "PASS_QUESTION", updatedItem);
    } catch (e) {
        await toast({
            type: "error",
            title: "We are sorry 😥.",
            content: `"Issue on No Pass Question: ${e}"`,
        });
    }
};

const setForUpdatedTemplate = async (template, sectionIndex, itemIndex, answer, scenario) => {
    let updatedTemplate = template;
    let setCurrent = true;

    let countSections = updatedTemplate.length;
    let currentItemsCount = updatedTemplate[sectionIndex]?.items?.length;

    if (updatedTemplate[sectionIndex]?.items[itemIndex]?.completed) {
        setCurrent = false;
    }

    updatedTemplate[sectionIndex].items[itemIndex].completed = true;
    updatedTemplate[sectionIndex].items[itemIndex].completedAt = moment().toISOString();
    updatedTemplate[sectionIndex].items[itemIndex].current = false;
    updatedTemplate[sectionIndex].items[itemIndex].answer = answer;
    updatedTemplate[sectionIndex].items[itemIndex].completedAt = moment().toISOString();

    if (setCurrent) {
        if (itemIndex + 1 >= currentItemsCount) {
            if (sectionIndex + 1 >= countSections) {
                if (scenario === "LOAD_OUT") {
                    syncStorage.set("loadOutTemplate", updatedTemplate);
                }else if (scenario === "RTS") {
                    syncStorage.set("rtsTemplate", updatedTemplate);
                } else {
                    syncStorage.set("fleetAdminTemplate", updatedTemplate);
                }
                return updatedTemplate;
            }
            updatedTemplate[sectionIndex + 1].items[0].current = true;
        } else {
            updatedTemplate[sectionIndex].items[itemIndex + 1].current = true;
        }
    }

    if (scenario === "LOAD_OUT") {
        syncStorage.set("loadOutTemplate", updatedTemplate);
    } else if (scenario === "RTS") {
        syncStorage.set("rtsTemplate", updatedTemplate);
    } else {
        syncStorage.set("fleetAdminTemplate", updatedTemplate);
    }

    return updatedTemplate;
};

const updateTemplate = async (api, template, sectionIndex, itemIndex, answer, scenario) => {
    try {
        let dispatch = memoryStorage.get("loadOutDispatch");

        if (scenario === "RTS") {
            dispatch = memoryStorage.get("rtsDispatch");
        }

        if (scenario === "FLEET_ADMIN") {
            dispatch = memoryStorage.get("fleetAdminDispatch");
        }

        let updatedTemplate = await setForUpdatedTemplate(template, sectionIndex, itemIndex, answer, scenario);

        if (answer?.type && answer.type === "MULTIPLE_CHOICES") {
            if (answer.choices && Array.isArray(answer.choices) && answer.choices.length > 0) {
                updatedTemplate[sectionIndex].items[itemIndex].content.choices = answer.choices;
            }
        }

        let updatedItem;

        try {
            updatedItem = updatedTemplate[sectionIndex].items[itemIndex];
        } catch (e) {
            await toast({
                type: "error",
                title: "We are sorry 😥.",
                content: `"Error in process: ${e}"`,
            });
        }

        return await dispatchAndUpdateForm(
            api,
            dispatch,
            updatedTemplate,
            scenario,
            answer?.type ? answer.type : null,
            updatedItem,
        );
    } catch (e) {
        await toast({
            type: "error",
            title: "We are sorry 😥.",
            content: `"Issue updating form: ${e}"`,
        });
    }
};

const dispatchAndUpdateForm = async (api, dispatch, updatedTemplate, currentScenario, type, updatedItem) => {
    dispatch({ type: "UPDATE_TEMPLATE", template: updatedTemplate });

    const params = {
        companyId: getCompanyId(),
        deviceId: Number.parseInt(syncStorage.get("deviceId")),
        vehicleId: Number.parseInt(syncStorage.get("vehicleId")),
        driverRouteId: Number.parseInt(syncStorage.get("driverRouteId")),
        kickoffLogId: Number.parseInt(syncStorage.get("kickoffLogId")),
        returnToStationId: Number.parseInt(syncStorage.get("returnToStationId")),
        fleetAdminLogId: Number.parseInt(syncStorage.get("fleetAdminLogId")),
        datetime: moment().toISOString(),
        scenario: currentScenario + "_FORM",
        type: type,
        updatedItem,
        form: updatedTemplate,
    };

    return await api.post("/api/complete/load_out/rts", params);
};

const inputRequestForEvent = (scenario, answer, type, sectionIndex, currentIndex) => {
    return {
        platform: syncStorage.get("platform"),
        mobileVersion: syncStorage.get('osVersion') || 14,
        buildNumber: 534,
        UID: syncStorage.get("deviceUID"),
        timezone: getCurrentTimezone(),
        kickoffLogId: Number.parseInt(syncStorage.get("kickoffLogId")),
        companyId: getCompanyId(),
        deviceId: Number.parseInt(syncStorage.get("deviceId")),
        vehicleId: Number.parseInt(syncStorage.get("vehicleId")),
        vehicle: syncStorage.get("vehicle"),
        driverRouteId: Number.parseInt(syncStorage.get("driverRouteId")),
        returnToStationId: Number.parseInt(syncStorage.get("returnToStationId")),
        fleetAdminLogId: Number.parseInt(syncStorage.get("fleetAdminLogId")),
        scenario: scenario,
        type: type,
        datetime: moment().toISOString(),
        answer: answer,
        currentSectionIndex: sectionIndex,
        currentItemIndex: currentIndex,
        userId: Number.parseInt(syncStorage.get("userId")),
        driverId: Number.parseInt(syncStorage.get("driverId")),
        stationId: Number.parseInt(syncStorage.get("stationId")),
    };
};

const updateTypeEvent = async (api, scenario, answer, type, sectionIndex, currentIndex) => {
    try {
        await api.post(
            "/api/update/load_out/rts",
            inputRequestForEvent(scenario, answer, type, sectionIndex, currentIndex),
        );
        return true;
    } catch (error) {
        await toast({
            type: "error",
            title: "We are sorry 😥.",
            content: `"Error in process: ${error}"`,
        });
        return false;
    }
};

const base64ToFile = (base64, fileName, mimeType) => {
    if (typeof base64 !== "string") {
        throw new Error(`base64ToFile: expected a string but received ${typeof base64}`);
    }
    const arr = base64.split(",");

    const mime = mimeType || arr[0]?.match(/:(.*?);/)?.[1];
    const data = arr.length > 1 ? arr[1] : arr[0];

    const byteCharacters = atob(data);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.codePointAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);

    return new File([byteArray], fileName, {
        type: mime || "image/jpeg",
    });
};

const uploadMediaToAmazonS3 = async (api, media, answer, questionType) => {
    if (!media) {
        return false;
    }

    if (
        !isDev() &&
        answer &&
        (answer.scenario === "LOAD_OUT" || answer.scenario === "RTS" || answer.scenario === "FLEET_ADMIN") &&
        (answer.type === "GAS_TANK_LEVEL" || answer.type === "MILEAGE" || answer.type === "INPUT")
    ) {
        const authToken = getToken();
        let infrastructure = 'upgradeed';
        try {
            if (authToken) infrastructure = parseToken()?.infrastructure ?? 'upgradeed';
        } catch (e) {
            infrastructure = 'upgradeed';
        }
        const params = {
            image: media?.base64,
            name: media?.fileName,
            input: JSON.stringify(answer),
            returnAfterImageUpload: false,
            Authorization: authToken,
            infrastructure: infrastructure
        };

        let response = await api.post("/api/mediaUploadS3", params);

        if (answer.scenario === "LOAD_OUT" || answer.scenario === "RTS" || answer.scenario === "FLEET_ADMIN") {
            let responseData = response.data;

            if (responseData[answer.type] !== undefined && responseData[answer.type].taskData !== undefined) {
                await api.post("/api/createTaskMileageAlert", {
                    taskData: responseData[answer.type].taskData,
                    mileageReview: questionType === 11
                });
            }
        }

        return response.data;
    } else if (media?.uri) {
        if (!media?.base64) {
            throw new Error("Media upload requires a base64 payload for the multipart fallback.");
        }
        const file = base64ToFile(media?.base64, media?.fileName, media?.type);
        let formData = new FormData();
        formData.append("image", file);
        formData.append("name", media?.fileName);
        formData.append("input", JSON.stringify(answer));
        let response = await api.post("/api/uploadMediaLoadOutRTS", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
        return response.data;
    }
};

const uploadMediaToS3 = async (api, media) => {
    if (!media) {
        return false;
    }

    if (media.uri) {
        if (media?.base64 && !isDev()) {
            const params = {
                image: media.base64,
                name: media.fileName,
                returnAfterImageUpload: true,
            };

            const response = await api.post("/api/mediaUploadS3", params);
            return response.data;
        } else if (media?.base64) {
            const file = base64ToFile(media?.base64, media?.fileName, media?.type);
            let formData = new FormData();
            formData.append("image", file);
            formData.append("name", media?.fileName);
            const response = await api.post("/api/dsp/uploadMediaToS3", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            return response.data;
        } else {
            throw new Error("Media upload requires a base64 payload for the multipart fallback.");
        }
    }
}

const allowDevice = async (api) => {
    const params = {
        scenario: "ALLOW",
        loadOutProcessCompleted: syncStorage.get("loadOutProcessCompleted"),
        driverRouteId: Number.parseInt(syncStorage.get("driverRouteId")),
        driverId: Number.parseInt(syncStorage.get("driverId")),
        userId: Number.parseInt(syncStorage.get("userId")),
        deviceId: Number.parseInt(syncStorage.get("deviceId")),
    };
    try {
        return await api.post("/api/device", params);
    } catch (error) {}
};

const getPendingIncident = async (api, stationId) => {
    const params = {
        actions: {
            response: {
                Incident: {
                    custom: {
                        functionName: "getPendingIncident",
                        get: "result",
                        excludes: [
                            "stations",
                            "employmentStatus",
                            "user",
                            "assignedManagers",
                            "payRate",
                            "company",
                            "schedules",
                            "cortexLogs",
                        ],
                        criteria: {
                            company: getCompanyId(),
                            station: stationId,
                            driver: Number.parseInt(syncStorage.get("driverId")),
                            date: moment().format("YYYY-MM-DD"),
                        },
                    },
                },
            },
        },
    };

    try {
        const { data } = await api.post("/api/lazy/manage/data", params);
        return data?.data?.result;
    } catch (error) {
        await toast({
            type: "error",
            title: "We are sorry 😥.",
            content: `"Error in process: ${error}"`,
        });
    }
};

const checkDriverRouteExistence = async (api) => {
    const params = {
        userId: Number.parseInt(syncStorage.get("userId")),
        driverId: Number.parseInt(syncStorage.get("driverId")),
        date: moment.tz(moment.tz.guess()).format("YYYY-MM-DD"),
        datetime: moment().toISOString(),
        driverRouteId: Number.parseInt(syncStorage.get("driverRouteId")),
        loadOutProcessCompleted: syncStorage.get("loadOutProcessCompleted"),
    };
    try {
        return await api.post("/api/check_driver_route_existence", params);
    } catch (error) {
        await toast({
            type: "error",
            title: "We are sorry 😥.",
            content: `"Error in process: ${error}"`,
        });
    }
};

const createUnscheduledDriverRoute = async (api) => {
    const params = {
        driverId: Number.parseInt(syncStorage.get("driverId")),
        date: moment.tz(moment.tz.guess()).format("YYYY-MM-DD"),
        datetime: moment().toISOString(),
        driverRouteId: Number.parseInt(syncStorage.get("driverRouteId")),
        loadOutProcessCompleted: syncStorage.get("loadOutProcessCompleted"),
    };
    try {
        return await api.post("/api/create_unscheduled_driver_route", params);
    } catch (error) {
        await toast({
            type: "error",
            title: "We are sorry 😥.",
            content: `"Error in process: ${error}"`,
        });
    }
};

const getAllEvents = async (api) => {
    try {
        const { data } = await api.get(
            `/api/v2/time_clock/current_shift?filter[date]=${moment().format("YYYY-MM-DD")}`,
        );
        if ("driverRouteId" in data) syncStorage.set("driverRouteId", data.driverRouteId);
        if ("kickoffLogId" in data) syncStorage.set("kickoffLogId", data.kickoffLogId);
        if ("kickoffLogProcessCompleted" in data)
            syncStorage.set("loadOutProcessCompleted", data.kickoffLogProcessCompleted);
        if ("returnToStationId" in data) syncStorage.set("returnToStationId", data.returnToStationId);
        if ("returnToStationProcessCompleted" in data)
            syncStorage.set("rtsProcessCompleted", data.returnToStationProcessCompleted);

        return data;
    } catch (error) {
        await toast({
            type: "error",
            title: "We are sorry 😥.",
            content: `"Error in process: ${error}"`,
        });
    }
};

const updateCurrentMileageAndGas = (api) => {
    const params = {
        driverRoute: {
            id: syncStorage.get("driverRouteId"),
        },
        driverRouteId: syncStorage.get("driverRouteId"),
        kickoffLogId: syncStorage.get("kickoffLogId"),
        returnToStationId: syncStorage.get("returnToStationId"),
        type: "GAS_TANK_LEVEL",
    };

    return api.post("/api/current_mileage_and_gas", params);
};

const validateVin = (api, payload, scannedVin) => {
    const params = {
        ...payload,
        kickoffLogId: syncStorage.get("kickoffLogId"),
        vin: scannedVin,
        driverRouteId: syncStorage.get("driverRouteId"),
        platform: syncStorage.get("platform"),
        datetime: moment().toISOString(),
        deviceId: syncStorage.get("deviceId"),
        driverId: syncStorage.get("driverId"),
        userId: syncStorage.get("userId"),
        stationId: syncStorage.get("stationId"),
        companyId: getCompanyId(),
    }

    return api.post("/api/validate_vin", params);
};

const validatePartialVin = (api, inputVin) => {
    const params = {
        deviceId: syncStorage.get("deviceId"),
        platform: syncStorage.get("platform"),
        kickoffLogId: syncStorage.get("kickoffLogId"),
        vin: inputVin.toUpperCase(),
        companyId: getCompanyId(),
        stationId: syncStorage.get("stationId"),
        datetime: moment().toISOString(),
    };

    return api.post("/api/validate_partial_vin", params);
};

const validateFullVin = (api, vinNumber, result) => {
    const params = {
        deviceId: syncStorage.get("deviceId"),
        platform: syncStorage.get("platform"),
        kickoffLogId: syncStorage.get("kickoffLogId"),
        vin: vinNumber,
        companyId: getCompanyId(),
        picture: result?.result?.s3URL,
        stationId: syncStorage.get("stationId"),
        datetime: moment().toISOString(),
        result,
    };

    return api.post("/api/validate_full_vin", params);
};

export {
    searchDeviceOnDatabase,
    setSessionTypeBasedOnSearchDevice,
    updateTemplatePassContentTypeViewOtherCase,
    setForUpdatedTemplate,
    updateTemplate,
    dispatchAndUpdateForm,
    inputRequestForEvent,
    updateTypeEvent,
    uploadMediaToAmazonS3,
    uploadMediaToS3,
    allowDevice,
    getPendingIncident,
    checkDriverRouteExistence,
    createUnscheduledDriverRoute,
    getAllEvents,
    updateCurrentMileageAndGas,
    validateVin,
    validatePartialVin,
    validateFullVin,
};
